/**
 * WorkspaceSecuritySection — shared workspace secrets, collapsed on load.
 * The shared workspace connection URL is being retired: the row shows no
 * value and no Copy, and the page never calls GET /api/workspace/mcp-url.
 * The Directive Signing Key uses SecretField like every other secret.
 */
import { useState } from "react";
import { DirectiveSigningKeySection } from "./DirectiveSigningKeySection";

export function WorkspaceSecuritySection({ workspaceId = "default", isLead }: { workspaceId?: string; isLead: boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <section id="team-section-security" style={{ marginBottom: 32 }}>
      <div className="sc-section-label">
        Workspace security
        {isLead && <span className="tp-lead-pill">LEAD</span>}
      </div>
      <div className="tp-lede">Shared workspace secrets. Most people never need these.</div>

      <div className="tp-card">
        <button className="tp-accordion-btn" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
          <span className={`tp-chevron${open ? " open" : ""}`} aria-hidden="true">▸</span>
          Show workspace connection and signing key
        </button>
        {open && (
          <div>
            <div className="tp-row">
              <div>
                <div className="tp-row-label">Workspace connection</div>
                <div className="tp-small">Shared MCP URL</div>
              </div>
              <div className="tp-small">
                The shared workspace connection is being retired. Use your personal connection URL from My Key.
              </div>
            </div>
            <DirectiveSigningKeySection workspaceId={workspaceId} />
          </div>
        )}
      </div>
    </section>
  );
}
